module.exports = __webpack_public_path__ + "img/globe_animated.73136cba.gif";